(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (paise) => {
    const f = (window.Flanq && window.Flanq.moneyFormat) || '₹{{amount_no_decimals}}';
    const amt = paise / 100;
    const decimals = Number.isInteger(amt) ? 0 : 2;
    const fmt = (n, d) => n.toLocaleString('en-IN', { minimumFractionDigits: d, maximumFractionDigits: d });
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, fmt(Math.round(amt), 0))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, fmt(Math.round(amt), 0))
            .replace(/\{\{\s*amount\s*\}\}/, fmt(amt, decimals))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fmt(amt, decimals));
  };
  const toast = (msg) => {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('on'), 2200);
  };

  /* ---------- cart drawer ---------- */
  const drawer = $('#CartDrawer');
  const open = () => { document.body.classList.add('cart-open'); drawer && drawer.setAttribute('aria-hidden', 'false'); };
  const close = () => { document.body.classList.remove('cart-open'); drawer && drawer.setAttribute('aria-hidden', 'true'); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshDrawer().then(open); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('#CartScrim')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  async function refreshDrawer() {
    if (!drawer) return;
    const r = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#shopify-section-cart-drawer') || doc.body;
    const dyn = $('#CartDrawerDyn') || drawer;
    dyn.innerHTML = fresh.outerHTML ? fresh.outerHTML : fresh.innerHTML;
    const count = doc.querySelector('[data-cart-count]');
    $$('[data-cart-count]').forEach((el) => { if (count) el.textContent = count.textContent; });
    const cta = $('#CartDrawerCta'); const empty = doc.querySelector('[data-cart-empty]');
    if (cta && empty) cta.hidden = empty.dataset.cartEmpty === '1';
    const tot = doc.querySelector('[data-cart-total]'), amt = $('[data-cta-amt]');
    if (tot && amt) amt.textContent = tot.textContent.trim();
  }

  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-promo]');
    if (!f) return;
    e.preventDefault();
    const code = f.querySelector('input').value.trim(); if (!code) return;
    const btn = f.querySelector('button'); btn.disabled = true;
    const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
    const j = await r.json().catch(() => ({}));
    btn.disabled = false;
    const ok = r.ok && (j.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
    if (!ok) { toast('That code didn\'t apply — check it and try again'); return; }
    toast('Code applied'); refreshDrawer();
  });
  async function addToCart(id, qty = 1) {
    const btn = document.activeElement;
    const r = await fetch(window.Flanq.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +qty }] }) });
    if (!r.ok) { const j = await r.json().catch(() => ({})); toast(j.description || 'Could not add to cart'); return; }
    await refreshDrawer(); open();
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    const qty = b.dataset.qtySource ? (+$(b.dataset.qtySource).textContent || 1) : (b.dataset.qty || 1);
    b.disabled = true; addToCart(b.dataset.add, qty).finally(() => { b.disabled = false; });
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-product-form]');
    if (!f) return;
    e.preventDefault();
    const id = f.querySelector('[name="id"]').value;
    const qty = f.querySelector('[name="quantity"]') ? f.querySelector('[name="quantity"]').value : 1;
    addToCart(id, qty);
  });
  // quantity change inside drawer / cart page
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    const line = +b.dataset.line, q = +b.dataset.lineChange;
    const r = await fetch(window.Flanq.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: q }) });
    if (!r.ok) { toast('Could not update cart'); return; }
    if (b.closest('#CartDrawer')) refreshDrawer(); else window.location.reload();
  });

  /* ---------- PDP: tiers, qty, gallery, sticky ---------- */
  function setQty(q) {
    q = Math.max(1, q);
    const tiers = $$('.tier[data-q]');
    const qtyEl = $('#Qty'), qtyInput = $('[data-product-form] [name="quantity"]');
    const atcAmt = $('#AtcAmt'), stickyAmt = $('#StickyAmt');
    const tierOffers = $('#TierOffers'), tierSavings = $('#TierSavings'), tierSavingsAmount = $('#TierSavingsAmount');
    const unitPrice = +(($('[data-unit-price]') || {}).dataset || {}).unitPrice || 0;
    if (qtyEl) qtyEl.textContent = q;
    if (qtyInput) qtyInput.value = q;
    $$('[data-qty-mirror]').forEach((mirror) => { mirror.textContent = q; });
    tiers.forEach((tier) => {
      const selected = +tier.dataset.q === q || Boolean(tier.dataset.minQ && q >= +tier.dataset.minQ);
      tier.classList.toggle('on', selected);
      tier.setAttribute('aria-checked', selected ? 'true' : 'false');
      tier.tabIndex = selected ? 0 : -1;
    });
    const tier = tiers.find((item) => +item.dataset.q === q) || tiers.find((item) => item.dataset.minQ && q >= +item.dataset.minQ);
    const total = tier && tier.dataset.unit ? +tier.dataset.unit * q : tier ? +tier.dataset.amt : unitPrice * q;
    if (atcAmt) atcAmt.textContent = '· ' + money(total);
    const tierTotal = $('#TierTotal');
    if (tierTotal) tierTotal.textContent = money(total);
    const saving = q === 2 && tierSavings
      ? +tierSavings.dataset.tier2Save
      : q >= 3 && tierSavings
        ? +tierSavings.dataset.tier3SaveUnit * q
        : 0;
    if (tierOffers) tierOffers.hidden = saving > 0;
    if (tierSavings) tierSavings.hidden = saving <= 0;
    if (tierSavingsAmount) tierSavingsAmount.textContent = money(saving);
    if (stickyAmt) stickyAmt.textContent = money(total);
  }
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      event.stopPropagation();
      const current = +($('#Qty') || {}).textContent || 1;
      setQty(Math.max(3, current + +step.dataset.qtyStep));
      return;
    }
    const tier = event.target.closest('.tier[data-q]');
    if (tier) {
      setQty(+tier.dataset.q);
      return;
    }
    const pick = event.target.closest('[data-pick-tier]');
    if (pick) {
      event.preventDefault();
      setQty(+pick.dataset.pickTier);
      const tierGroup = $('#Tiers');
      if (tierGroup) tierGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  document.addEventListener('keydown', (event) => {
    const tier = event.target.closest('.tier[data-q]');
    if (!tier || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    setQty(+tier.dataset.q);
  });
  /* gallery: scroll-snap slider + thumbs below */
  const slides = $('#Slides');
  if (slides) {
    const items = $$('[data-slide]', slides);
    const thumbs = $$('#Thumbs [data-i]');
    let cur = 0;
    const setCur = (i) => {
      cur = Math.max(0, Math.min(items.length - 1, i));
      thumbs.forEach((t) => t.classList.toggle('on', +t.dataset.i === cur));
      const on = thumbs[cur]; if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      const c = $('#ImgCount'); if (c) c.textContent = cur + 1;
    };
    const goTo = (i) => { i = Math.max(0, Math.min(items.length - 1, i)); slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); setCur(i); };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.i)));
    $$('[data-slide-step]').forEach((b) => b.addEventListener('click', () => goTo(cur + (+b.dataset.slideStep))));
    let deb;
    slides.addEventListener('scroll', () => { clearTimeout(deb); deb = setTimeout(() => setCur(Math.round(slides.scrollLeft / slides.clientWidth)), 60); }, { passive: true });
    slides.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goTo(cur + 1); if (e.key === 'ArrowLeft') goTo(cur - 1); });
    slides.tabIndex = 0;
  }
  const sticky = $('.stickybar'), buy = $('.buy .atc');
  if (sticky && buy) {
    document.body.classList.add('has-sticky');
    let raf = 0;
    const paint = () => {
      raf = 0;
      const rect = buy.getBoundingClientRect();
      const mainAtcVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      sticky.classList.toggle('is-visible', !mainAtcVisible);
    };
    const schedulePaint = () => {
      if (!raf) raf = requestAnimationFrame(paint);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(schedulePaint, { threshold: 0 }).observe(buy);
    }
    window.addEventListener('scroll', schedulePaint, { passive: true });
    window.addEventListener('resize', schedulePaint);
    paint();
  }

  /* ---------- product video controls ---------- */
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-video-toggle]');
    if (!button) return;
    const video = button.closest('.product-video__frame').querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play();
      button.setAttribute('aria-label', 'Pause product video');
      button.querySelector('[data-video-toggle-label]').textContent = 'Pause';
    } else {
      video.pause();
      button.setAttribute('aria-label', 'Play product video');
      button.querySelector('[data-video-toggle-label]').textContent = 'Play';
    }
  });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.product-video video').forEach((video) => video.pause());
  }

  /* ---------- Doran reviews: skin the same-origin widget iframe to the theme palette ---------- */
  const DORAN_CSS = '@import url("https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700;12..96,800&family=Instrument+Sans:wght@400;500;600&family=DM+Mono:wght@500&display=swap");'
    + 'body{--rating-color:ACCENT;--button-background-color:ACCENT;--button-text-color:#fff;font-family:"Instrument Sans",system-ui,sans-serif!important;color:INK}'
    + 'h1,h2,h3{font-family:"Bricolage Grotesque","Instrument Sans",sans-serif!important;letter-spacing:-.01em}'
    + 'button{border-radius:10px!important}';
  function skinDoran() {
    const f = document.querySelector('#reviews iframe');
    if (!f) return;
    let d; try { d = f.contentDocument; } catch (e) { return; }
    if (!d || !d.head) return false;
    if (d.getElementById('flanq-doran')) return true;
    const cs = getComputedStyle(document.documentElement);
    const s = d.createElement('style'); s.id = 'flanq-doran';
    s.textContent = DORAN_CSS.replace(/ACCENT/g, cs.getPropertyValue('--accent').trim() || '#0F5F5C').replace(/INK/g, cs.getPropertyValue('--ink').trim() || '#161B19');
    d.head.appendChild(s); return true;
  }
  const rv = document.querySelector('#reviews');
  if (rv && !skinDoran()) {
    let tries = 0;
    const mo = new MutationObserver(() => { if (skinDoran()) mo.disconnect(); });
    mo.observe(rv, { childList: true, subtree: true });
    const t = setInterval(() => { if (skinDoran() || ++tries > 10) { clearInterval(t); mo.disconnect(); } }, 1500);
  }

  /* ---------- mobile menu ---------- */
  const mm = $('#MobMenu');
  const mmOpen = () => { if (!mm) return; mm.classList.add('open'); mm.setAttribute('aria-hidden', 'false'); document.body.classList.add('menu-open'); };
  const mmClose = () => { if (!mm) return; mm.classList.remove('open'); mm.setAttribute('aria-hidden', 'true'); document.body.classList.remove('menu-open'); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); mmOpen(); }
    else if (e.target.closest('[data-menu-close]')) mmClose();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') mmClose(); });
})();
